import React, { Component } from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import TourDetailsPage from './tourDetail';
import { FavouriteTour, GetTourDetails } from '../../models/tour';
import InquiryModal from './InquiryModal';
import AppUtils from '../../apputils';



class tourDetails extends Component {
    constructor() {
        super()
        this.state = {
            tourId: '',
            tourDetails: false,
            favTour:false,
            tour_name:'',
            tour_duration:'',
            tour_cost:'',
            tour_theme:'',
            tour_images:[],
            tour_cities:'',
            tour_highlights:[],
            tour_details:'',
            isModalOpen:false

        }

        this.favData = {

        }
    }

    componentDidMount = () => {
        this.setState({
            tourId: this.props.componentprops.match.params.id,
            tourDetails: true,
        })
    }

    CloseModal = ()=>{
       
        this.setState({
            isModalOpen:false
        })
        this.HandleRouting('travel')
    }
    
    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    GetMoreDetails = ()=>{

        if(localStorage.getItem('current_user_id') === '' || localStorage.getItem('current_user_id') === null || localStorage.getItem('current_user_id') === undefined){
            this.HandleRouting('login') 
        }

        else{


            this.favData = {
                tour_id:this.state.tourId,
                user_id:localStorage.getItem('current_user_id')
            }

            this.setState({
                favTour:true
            })


            console.log(this.favData)
    
       // alert('lll')
        // this.setState({
        //     isModalOpen:true
        // })
    }

    }

    HandleFavouriteTourSuccessResponse = (res)=>{
        if(res !== false){
            this.setState({
                favTour:false,
                isModalOpen:true
            })
        }
        else{
            this.setState({
                favTour:false
            })
        }
    }

    HandleGetTourDetailsSuccessResponse = (res) => {
        if (res !== false) {
            console.log(res.data.tourdetails.rows[0])
             let images = [];
//            var images = res.data.tourdetails.rows[0].tour_image
                images = res.data.tourdetails.rows[0].tour_image.split(',')
                images.pop();
                console.log(images);

                let highlights = [];
                highlights = res.data.tourdetails.rows[0].tour_highlights.split('\n')
                // if(highlights.length <= 1){
                //     highlights = highlights
                // }
                // else{
                //     highlights = highlights.pop();
                // }
                
                console.log(highlights);

            this.setState({

                tour_name:res.data.tourdetails.rows[0].tour_name,
                tour_duration:res.data.tourdetails.rows[0].tour_duration,
                tour_cost:res.data.tourdetails.rows[0].tour_pricing,
                tour_theme:res.data.tourdetails.rows[0].tour_theme,
                tour_images:images,
                tour_cities:res.data.tourdetails.rows[0].tour_cities,
                tour_details:res.data.tourdetails.rows[0].tour_details,
                tour_highlights:highlights,
                tourDetails: false
            })
        }

        else {
            this.setState({
                tourDetails: false
            })
        }
    }

    render() {
       
        return (
            <div>
                <TourDetailsPage {...this.props} mystate = {this.state} GetMoreDetails = {this.GetMoreDetails} />
                <InquiryModal {...this.props} mystate = {this.state} CloseModal={this.CloseModal} />
                {((this.state.tourDetails === true) ? GetTourDetails(this.props.PnkStore, this.state.tourId, this.HandleGetTourDetailsSuccessResponse) : "")}
                {((this.state.favTour === true) ? FavouriteTour(this.props.PnkStore, this.favData, this.HandleFavouriteTourSuccessResponse) : "")}
            </div>
        )
    }
}

export const TourDetails = PnkConnect(tourDetails, '');